import React, { Component } from "react";
import { ListGroup, ListGroupItem } from "react-bootstrap";
import { LinkContainer,
         Link
         } from "react-router-bootstrap";
import LoaderButton from "../components/LoaderButton";
import "./Home.css";
import axios from 'axios';
import ReactGA from 'react-ga';
import websiteIcon from './widget.svg';
import spaceshipIcon from './spaceship.svg';
import pageIcon from './single-folded-content.svg';
import notesIcon from './notes.svg';
import layersIcon from './layers-3.svg';
import vectorIcon from './vector.svg';
import preferencesIcon from './preferences.svg';
import archivePaperIcon from './archive-paper.svg';
import globeIcon from './world.svg';
import heartIcon from './heart-2.svg';
import compassIcon from './compass-05.svg';
import briefcaseIcon from './briefcase-24.svg';
import walletIcon from './wallet-43.svg';
import pencilIcon from './pencil.svg';
import thumbsUpIcon from './like-2.svg';
import archiveIcon from './archive-2.svg';
import exampleMov from './Animal Farm Chapter 1.mov';
import config from "../config";


export default class Home extends Component {
  constructor(props) {
    super(props);

    this.initializeReactGA();

    this.state = {
      isLoading: false,
      summaries: this.getSummaryList()
    };
  }

  getSummaryList() {
    console.log(!localStorage.getItem('cache_summariesList'));
    // Cache the summarie lists to make the system faster
    if (!localStorage.getItem('cache_summariesList')) {
      return []; // start fresh
    } else {
      return JSON.parse(localStorage.getItem('cache_summariesList'));
    }
  }

  toSignup() {
    this.props.history.push("/signup");
  }

  toNew() {
    this.props.history.push("/summary/new");
  }

  initializeReactGA() {
    ReactGA.initialize('UA-136595020-1');
    ReactGA.pageview('/Homepage');
  }

  componentWillMount() {
  }

  componentDidMount() {
    this.initializeReactGA();

    this.setState({ isLoading: true });

    if (!localStorage.getItem('cache_isAuthenticated')) {
      console.log('User not authenticated...')
      this.setState({ isLoading: false });
      return;
    }

    if ((!localStorage.getItem('cache_summariesList'))
        &&
        (localStorage.getItem('cache_basicAuth'))){

        console.log('Pulling Summary List...')
        // Save summary
        axios.post(config.API_HOST + '/summary/list/',
                   {user_id: localStorage.getItem('cache_userId')},
                   {headers: { 'Content-Type': "application/json",
                              Authorization: "Basic " + localStorage.getItem('cache_basicAuth')}})
        .then(res => {
          // Put response data in the console for now during dev
          console.log("Summaries:")
          this.setState({ summaries: res.data});
          localStorage.setItem('cache_summariesList', JSON.stringify(res.data));
          this.setState({ isLoading: false });
          return res.data;
        })
        .catch (e =>
        {console.log('error ' + e.message);
          // take down loading symbol
         this.setState({ isLoading: false });
        });
    } else {
      // no need to load the summaries, we already have them
      this.setState({ isLoading: false });
    }
  }

  clickSummary(summary) {
    console.log('Running Click Summary...' + summary.id + " " + summary.title);
    ReactGA.event({
      category: 'User',
      action: 'View Summary'
    });
    this.props.setSummary(summary);
  }

  renderSummariesList(summaries) {
    if (this.state.isLoading === true) {
      return ( <div>
              <LinkContainer
                key="new"
                to="/summary/new"
              >
                <ListGroupItem>
                  <h4>
                    <b>{"\uFF0B"}</b> Create a new summary
                  </h4>
                </ListGroupItem>
              </LinkContainer>
              <h3> Loading Summaries... </h3>
             </div>);
    } else {
      return [{}].concat(summaries).map(
        (summary, i) =>
          i !== 0
            ? <LinkContainer
                key={summary.id}
                to={'/summary/view'}
                onClick={() => {this.clickSummary(summary)}}
              >
                <ListGroupItem
                  header={new Date(summary.create_time).toLocaleString()}>
                  {summary.title.substring(0, 100)}
                </ListGroupItem>
              </LinkContainer>
            : <LinkContainer
                key="new"
                to="/summary/new"
              >
                <ListGroupItem>
                  <h4>
                    <b>{"\uFF0B"}</b> Create a new summary
                  </h4>
                </ListGroupItem>
              </LinkContainer>,
      );
    }//if
  }

  renderLander() {
    return (

      <div className="lander">

      <h2> Learn Faster <img src={spaceshipIcon} /> </h2>

      <LoaderButton
              block
              bsStyle="primary"
              bsSize="large"
              type="submit"
              isLoading={this.state.isLoading}
              text="Create Summary"
              loadingText="…"
              onClick={this.toNew.bind(this)}
            />

            <video
              width='100%'
              id="background-video"
              loop
              autoPlay>
                <source src={exampleMov} type="video/mp4" />
            </video>

      <h2 align='left'>What does Autonote do?</h2>
      <ul align='left'>
        <li> <img src={thumbsUpIcon} /> An auto summarization tool that removes info you don't need, so you can read text faster </li>
        <li> <img src={layersIcon} /> Autonote looks for key topics in the text using 3 different summarization algorithms. </li>
        <li> <img src={preferencesIcon} /> The algorithms take in your settings about topics you want to focus on and desired summary size. </li>
        <li> <img src={vectorIcon} /> These algorithms combine what they find into one common list. </li>
        <li> <img src={pageIcon} /> Then autonote cleans the text to present only the important sentences, saving you time. </li>
      </ul>

      <h2 align='left'>What can I input?</h2>
      <ul align='left'>
        <li> <img src={notesIcon} /> Text you copy & pasted </li>
        <li> <img src={websiteIcon} /> Urls of websites </li>
        <li> <img src={archivePaperIcon} /> Pdf's you upload. Even those scanned PDF's that you can't copy and paste. </li>
      </ul>

      <h2 align='left'>What subjects?</h2>
      <ul align='left'>
        <li> <img src={globeIcon} /> Anything. </li>
        <li> <img src={compassIcon} /> History </li>
        <li> <img src={archiveIcon} /> English </li>
        <li> <img src={heartIcon} /> Medical </li>
        <li> <img src={walletIcon} /> Business </li>
        <li> <img src={briefcaseIcon} /> Legal Briefs </li>
      </ul>

      <h2 align='left'>Who is Autonote for?</h2>
      <ul align='left'>
        <li> <img src={pencilIcon} /> Students (college, highschool, grad school) </li>
        <li> <img src={briefcaseIcon} /> Paralegals & Laywers </li>
        <li> <img src={heartIcon} /> Medical Researchers </li>
        <li> <img src={walletIcon} /> Business/Stock Researcher </li>
      </ul>

      <p align='left'> Disclaimer: Autonote only provides a summary and therefore information is ommitted.
      Anyone who needs to fully understand the text should read the full text.
      Autonote is also not responsible for the security/storage of the data which you input / autonote creates.</p>

      </div>
    );
  }

  renderSummaries() {
    return (
      <div className="summaries">
      <ListGroup>
      {this.renderSummariesList(this.state.summaries)}
  </ListGroup>
  </div>
  );
}

render() {
  return (
    <div className="Home">
    {this.props.isAuthenticated ? this.renderSummaries() : this.renderLander()}
</div>
);
}
}
